import React, { useEffect, useState } from 'react'
import { Popover, Tooltip, message } from 'antd'
import { MoreOutlined, ArrowRightOutlined } from '@ant-design/icons'
import moment from 'moment'
import styles from '../mymaps.module.sass'
import AeroImage from '../../../AeroComponents/Image'
import AeroButton from '../../../AeroComponents/Button'
import { IMAGES_SRC } from '../../../AeroComponents/Image/image.constants'
import { capitalize, textShortner } from '../../../Services/UtilityService'
import { goTo } from '../../../Services/NavigationService'
import { PROCESSING_STATUS_ENUMS } from '../constants'
import { pushEventToMixpanel } from '../../../Services/MixpanelService'
import MapThumbnail from '../../../AeroComponents/GoogleMap/map-thumbnail'

const MapCard = props => {
	const { demo, data, openShareModal, openDeleteModal } = props
	const [footerText, setFooterText] = useState({ text: '', action: null })

	const openProcessedMap = () => {
		pushEventToMixpanel('Map Viewed', {
			'Map Name': data.processingName,
		})
		window.open(data.processedData, '_blank')
	}

	useEffect(() => {
		if (data.status === 'CREATED') {
			if (data.stage === 0) {
				setFooterText({ text: 'Configure Parameters', action: () => goTo(`edit-map/${data.processingId}`) })
			} else if (data.stage === 1) {
				setFooterText({ text: 'Upload Images', action: () => goTo(`edit-map/${data.processingId}`) })
			} else if (data.stage === 2) {
				setFooterText({ text: 'Confirm Details', action: () => goTo(`edit-map/${data.processingId}`) })
			} else {
				setFooterText({ text: 'Processing In-progress', action: () => message.info('Processing is going on, we will notify you when it is ready!') })
			}
		} else if (data.status === 'PROCESSING' || data.status === 'WAITING_ADD_GCP' || data.status === 'ON_QUEUE') {
			setFooterText({ text: 'Processing In-progress', action: () => message.info('Processing is going on, we will notify you when it is ready!') })
		} else if (data.status === 'ERROR') {
			setFooterText({ text: 'Contact Us', action: () => window.open('https://aerologix.atlassian.net/servicedesk/customer/portal/3/group/4/create/20', '_blank') })
		} else if (data.status === 'ENDED') {
			setFooterText({ text: 'Open Map', action: () => openProcessedMap() })
		}
	}, [data])

	const path = JSON.parse(data.boundaryCoordinates)
	const polyPath = [
		{ lat: path?.coord_0.latitude, lng: path?.coord_0.longitude },
		{ lat: path?.coord_1.latitude, lng: path?.coord_1.longitude },
		{ lat: path?.coord_2.latitude, lng: path?.coord_2.longitude },
		{ lat: path?.coord_3.latitude, lng: path?.coord_3.longitude },
	]

	const centerLat = (path?.coord_0.latitude + path?.coord_1.latitude + path?.coord_2.latitude + path?.coord_3.latitude) / 4
	const centerLon = (path?.coord_0.longitude + path?.coord_1.longitude + path?.coord_2.longitude + path?.coord_3.longitude) / 4

	return (
		<div style={{ marginTop: demo ? null : '32px' }}>
			{demo ? <div className={styles['demo-wrapper']}>Demo</div> : null}

			<div className={styles['card-wrapper']}>
				{data.status !== 'ENDED' ? (
					<AeroImage otherstyles={{ borderRadius: '7px 7px 0px 0px', width: 'inherit' }} src={IMAGES_SRC.MAP_PLACEHOLDER} alt='map-asset' />
				) : (
					<MapThumbnail center={{ lat: centerLat, lng: centerLon }} polyPath={polyPath} />
				)}
				<div
					onClick={() => footerText.action()}
					style={{
						cursor:
							(data.status === 'CREATED' && data.stage === 3) || (data.status === 'PROCESSING' || data.status === 'WAITING_ADD_GCP' || data.status === 'ON_QUEUE')
								? 'default'
								: 'pointer',
					}}
					className={styles['clickable-thumbnail-div']}
				>
					<div style={{ marginLeft: '13px' }}>
						<div className={styles['two-ends-items']}>
							<div className={styles['card-head']}>
								{data.processingName.length < 15 ? (
									capitalize(data.processingName)
								) : (
									<Tooltip title={capitalize(data.processingName)}>{textShortner(capitalize(data.processingName), 15)}</Tooltip>
								)}
							</div>
							<Popover
								content={
									<div>
										<div>
											<AeroButton
												onClick={() => goTo(`edit-map/${data.processingId}`)}
												disabled={data.status !== 'CREATED'}
												otherstyles={{ textAlign: 'left' }}
												block
												type='text'
											>
												<AeroImage className={styles['action-btn-asset']} alt='edit' src={IMAGES_SRC.EDIT_ICON} /> Edit
											</AeroButton>
										</div>
										<div>
											<AeroButton
												disabled={data.status !== 'ENDED'}
												onClick={() => openShareModal(data)}
												otherstyles={{ textAlign: 'left' }}
												block
												type='text'
											>
												<AeroImage className={styles['action-btn-asset']} alt='share' src={IMAGES_SRC.SHARE_ICON} /> Share
											</AeroButton>
										</div>
										<div>
											<AeroButton disabled={demo} onClick={() => openDeleteModal(data)} otherstyles={{ textAlign: 'left' }} block type='text'>
												<AeroImage className={styles['action-btn-asset']} alt='delete' src={IMAGES_SRC.TRASH_ICON} /> Delete
											</AeroButton>
										</div>
									</div>
								}
							>
								<AeroButton otherstyles={{ fontSize: '20px', position: 'relative', bottom: '7px', color: 'black' }} type='link'>
									<MoreOutlined />
								</AeroButton>
							</Popover>
						</div>
						<div className={styles['date-wrapper']}>
							{moment
								.utc(data.createdAt)
								.local()
								.format('DD/MM/YYYY')}
						</div>
						<div
							style={{ border: `1px solid ${PROCESSING_STATUS_ENUMS[data.status].borderColor}`, background: PROCESSING_STATUS_ENUMS[data.status].backgroundColor }}
							className={styles['status-wrapper']}
						>
							<span style={{ marginLeft: '10px' }}>Processing {PROCESSING_STATUS_ENUMS[data.status].label}</span>
						</div>
					</div>
					<div className={styles['footer-wrapper']}>
						<span style={{ flexGrow: '1' }}>{footerText.text}</span>
						<ArrowRightOutlined />
					</div>
				</div>
			</div>
		</div>
	)
}

export default MapCard
